import React, { useState, useEffect } from 'react';

function NewsAndTrendsSection({ brandStyles = { primaryGreen: '#0a1e1a' }, trendingProducts: propTrendingProducts = [] }) {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [activeCard, setActiveCard] = useState(null);

  const products = propTrendingProducts;
  const Video_id1 = '5PIwfZIrLZs';
  const Video_id2 = 'zoKo2d5YZGI';
  
  const videos = [
    { id: 1, src: `https://www.youtube.com/embed/${Video_id1}`, title: 'Livelihoods' }, 
    { id: 2, src: `https://www.youtube.com/embed/${Video_id2}`, title: 'Witnessing Agroecology' }, 
  ];

  // Effect for smooth mouse-based parallax
  useEffect(() => {
    const handleMouseMove = (e) => {
      const centerX = window.innerWidth / 2;
      const centerY = window.innerHeight / 2;
      
      const normalizedX = (e.clientX - centerX) / centerX;
      const normalizedY = (e.clientY - centerY) / centerY;

      setMousePosition({ 
          x: normalizedX * 5, 
          y: normalizedY * 5 
      });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  // Inline style for the entire section
  const sectionStyle = {
    background: `linear-gradient(135deg, ${brandStyles.primaryGreen} 0%, #91c949 10%, #394c92 100%)`,
    minHeight: "85vh",
    width: "100%",
  };
  
  return (
    <section
      className="position-relative overflow-hidden py-5"
      style={sectionStyle}
    >
      {/* Animated Background Grid */}
      <div 
        className="position-absolute w-100 h-100" 
        style={{
          top: 0,
          left: 0,
          backgroundImage: `
            linear-gradient(rgba(157, 255, 0, 0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(0, 255, 170, 0.03) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px',
          animation: 'gridMove 20s linear infinite',
          pointerEvents: 'none',
        }}
      />

      {/* Floating Orbs (Parallax Effect) */}
      <div 
        className="position-absolute rounded-circle d-none d-md-block"
        style={{
          width: '400px',
          height: '400px',
          background: 'radial-gradient(circle, rgba(143, 245, 27, 0.15), transparent)',
          filter: 'blur(60px)',
          top: '10%',
          left: `calc(20% + ${mousePosition.x}px)`,
          transition: 'all 0.3s ease-out',
          pointerEvents: 'none',
        }}
      />
      <div 
        className="position-absolute rounded-circle d-none d-md-block"
        style={{
          width: '300px',
          height: '300px',
          background: 'radial-gradient(circle, rgba(64, 132, 221, 0.15), transparent)',
          filter: 'blur(60px)',
          bottom: '15%',
          right: `calc(15% - ${mousePosition.y}px)`,
          transition: 'all 0.3s ease-out',
          pointerEvents: 'none',
        }}
      />

      <style>{`
        /* Keyframes for the scrolling carousel effect */
        @keyframes scrollTrend {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        @keyframes gridMove {
          0% { transform: translateY(0); }
          100% { transform: translateY(50px); }
        }
        @keyframes glow {
          0%, 100% { box-shadow: 0 0 20px rgba(0, 255, 170, 0.3); }
          50% { box-shadow: 0 0 40px rgba(0, 255, 170, 0.6), 0 0 60px rgba(0, 255, 170, 0.3); }
        }
        /* Auto-scroll animation is now the only way to move the cards */
        .trend-scroll-container-animated {
            width: max-content;
            animation: scrollTrend 50s linear infinite;
        }
        .trend-scroll-container-animated:hover {
            animation-play-state: paused;
        }
        /* REMOVED: trend-scroll-container-mobile CSS that enabled overflow-x: auto */
        
        .glass-card {
          background: rgba(255, 255, 255, 0.05);
          backdrop-filter: blur(10px);
          border: 1px solid rgba(255, 255, 255, 0.1);
        }
        .neon-border {
          position: relative;
          border: 2px solid transparent;
          background: linear-gradient(rgba(10, 30, 26, 0.9), rgba(10, 30, 26, 0.9)) padding-box,
                      linear-gradient(135deg, #00ffaa, #457beeff) border-box;
        }
        .video-glow {
          animation: glow 3s ease-in-out infinite;
        }
        .card-hover {
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
        .card-hover:hover {
          transform: translateY(-15px) scale(1.05);
          z-index: 10;
        }
      `}</style>

      <div className="container-fluid position-relative p-4 p-md-2" style={{ zIndex: 1 }}>
        <div className="row g-4">
          
          {/* LEFT COLUMN: Videos */}
          <div className="col-lg-5 col-12 d-flex flex-column">
            {/* Section Header */}
            <div className="text-center mb-4">
              <div className="d-inline-block position-relative">
                <h2 className="fw-bold text-white mb-2" style={{
                  textShadow: '0 0 10px rgba(0, 255, 170, 0.5)',
                  letterSpacing: '2px',
                }}>
                  FEATURED
                </h2>
                <div style={{
                  height: '3px',
                  background: 'linear-gradient(90deg, transparent, #00ffaa, transparent)',
                  marginTop: '10px',
                }}/>
              </div>
            </div>

            {/* Video Cards */}
            <div className="d-flex flex-column gap-4 flex-grow-1">
              {videos.map((video, index) => (
                <div 
                  key={video.id} 
                  className="neon-border rounded-4 overflow-hidden video-glow"
                >
                  <h4 className="text-white fw-bold fw-light mb-0 p-3" style={{ fontSize: '1rem'}}>
                    {video.title}
                  </h4>
                  
                  <div className="position-relative" style={{ paddingTop: '56.25%' }}> 
                    <iframe
                      src={`${video.src}?autoplay=1&mute=1&loop=1&playlist=${video.src.split('/').pop().replace('embed/', '')}&controls=0&modestbranding=1&rel=0&showinfo=0&iv_load_policy=3&disablekb=1`}
                      title={`Featured video ${index + 1}`}
                      allow="autoplay; encrypted-media; fullscreen"
                      className="position-absolute top-0 start-0 w-100 h-100"
                      style={{ border: 'none' }}
                    />
                    {/* Overlay Corner Accent */}
                    <div className="position-absolute" style={{
                      top: 0,
                      left: 0,
                      width: '60px',
                      height: '60px',
                      background: 'linear-gradient(135deg, rgba(0, 255, 170, 0.3), transparent)',
                      borderTopLeftRadius: '1rem',
                    }}/>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT COLUMN: News & Trends */}
          <div className="col-lg-7 col-12 d-flex flex-column ">
            {/* Section Header */}
            <div className="text-center mb-4">
              <div className="d-inline-block position-relative">
                <h2 className="fw-bold text-white mb-2" style={{
                  textShadow: '0 0 10px rgba(47, 60, 182, 0.5)',
                  letterSpacing: '2px',
                }}>
                  News & Trends
                </h2>
                <div style={{
                  height: '3px',
                  background: 'linear-gradient(90deg, transparent, #2b7ae2ff, transparent)',
                  marginTop: '10px',
                }}/>
              </div>
            </div>

            {/* Scrolling Cards Container */}
            <div 
              className="position-relative overflow-hidden flex-grow-1 rounded-4 mt-4 d-flex align-items-center" 
              style={{ 
                background: 'rgba(0, 0, 0, 0.2)',
                padding: '30px 0',
              }}
            >
              {/* Card Row */}
              <div 
                // FIX: Removed 'trend-scroll-container-mobile'
                className={`d-flex align-items-center ${products.length > 0 ? 'trend-scroll-container-animated' : ''}`} 
                style={{ gap: '25px', paddingLeft: '25px' }}
              >
                {products.length > 0 && [...products, ...products].map((product, index) => (
                  <div
                    key={index}
                    className="glass-card rounded-4 overflow-hidden d-flex flex-column card-hover flex-shrink-0"
                    style={{
                      minWidth: "320px",
                      maxWidth: "320px",
                      height: "480px",
                      cursor: 'pointer',
                      border: activeCard === index ? '2px solid #00ffaa' : '1px solid rgba(255, 255, 255, 0.1)',
                    }}
                    onMouseEnter={() => setActiveCard(index)}
                    onMouseLeave={() => setActiveCard(null)}
                  >
                    {/* Image Section with Gradient Overlay */}
                    <div 
                      className="position-relative" 
                      style={{ height: "264px", overflow: "hidden" }} 
                    >
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-100 h-100" 
                        style={{
                          display: 'block', 
                          objectFit: "cover",
                          filter: activeCard === index ? 'brightness(1.1)' : 'brightness(0.9)',
                          transition: "all 0.4s ease",
                        }}
                      />
                      <div className="position-absolute w-100 h-100 top-0 start-0" style={{
                        background: 'linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.7) 100%)',
                      }}/>
                      
                      {/* Floating Badge */}
                      <div className="position-absolute top-0 end-0 m-3 px-3 py-1 rounded-pill" style={{
                        background: 'rgba(0, 255, 170, 0.2)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(234, 240, 233, 0.5)',
                        fontSize: '0.75rem',
                        color: '#2a81bbff',
                        fontWeight: '600',
                      }}>
                        TRENDING
                      </div>
                    </div>

                    {/* Content Section */}
                    <div className="p-4 d-flex flex-column justify-content-between flex-grow-1">
                      <div>
                        <h5 className="fw-bold mb-2 text-white" style={{ 
                          fontSize: "1.4rem",
                          lineHeight: '1.3',
                        }}>
                          {product.name}
                        </h5>
                        <p className="mb-3" style={{
                          color: 'rgba(255, 255, 255, 0.7)',
                          fontSize: '0.95rem',
                        }}>
                          {product.tagline}
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default NewsAndTrendsSection;